module.exports = __webpack_public_path__ + "static/media/ratingscale_active.9cabc61a.svg";